import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api/useRestQuery';

export const MISSION_CONTROL_USER_PREFERENCES_URL = '/i/missionControl/userPreferences';

export type QueryMissionControlUserPreferencesResponse = {
  campaignLabelIds: number[];
  datePreset: string;
  messageTypeIds: number[];
  subscribedGoalIds: string[];
};

export type UseQueryMissionControlUserPreferencesState = ReturnType<
  typeof useQueryMissionControlUserPreferences
>;

export const useQueryMissionControlUserPreferences = (
  params?: Record<string, unknown>,
  options?: RestQueryHookOptions<QueryMissionControlUserPreferencesResponse>,
) => {
  const {
    data,
    isLoading,
    error: errorMessage,
    isError: hasError,
    refetch,
  } = useRestQuery<QueryMissionControlUserPreferencesResponse>(
    MISSION_CONTROL_USER_PREFERENCES_URL,
    params,
    options,
  );

  return {
    userPreferences: data,
    isLoading,
    hasError,
    errorMessage,
    refetch,
  };
};
